module.exports = __webpack_public_path__ + "img/t5-img3.bb3855cc.png";